import request from '@/api/base'
const getRateList = (params) => {
  if (process.env.NODE_ENV === 'development') {
    // params.mockApi = true
  }
  return request.post('/portal/contract/tax/queryListNew', params)
}
const getEnableRateList = (params) => {
  // params.mockApi = true
  return request.post('/portal/contract/tax/queryListForContractNew', params)
}
const enableTax = (params) => {
  return request.post('/portal/contract/tax/isEnableContractTax', params)
}
const getTaxSerialNumber = (params) => {
  // params.mockApi = true
  return request.get('/portal/contract/tax/getCodeInfo', {params})
}
const deleteRate = (params) => {
  return request.post('/portal/contract/tax/deleteContractTaxNew', params)
}
const addRate = (params) => {
  // params.mockApi = true
  return request.post('/portal/contract/tax/addContractTaxNew', params)
}
const updateRate = (params) => {
  // params.mockApi = true
  return request.post('/portal/contract/tax/updateContractTaxNew', params)
}

export default {
  getRateList,
  getEnableRateList,
  enableTax,
  getTaxSerialNumber,
  deleteRate,
  addRate,
  updateRate
}



// WEBPACK FOOTER //
// ./src/area-contract/api/rateService.js